import type { LucideIcon } from 'lucide-react';
import type { HabitCategory } from '@contracts';
import { HeartPulse, Sparkles, BookOpen, CircleEllipsis } from '@ui/shared/icons';

/**
 * Category -> accent-token-name / icon / label mapping shared by every habit
 * row (Today view, habit list, habit form). `HabitCategory`'s contract
 * values (`self_care`) don't match the token naming (`--accent-selfcare`,
 * no underscore) — this is the one place that seam is bridged so no
 * component has to remember the mismatch itself.
 */
export interface HabitCategoryMeta {
  readonly label: string;
  /** CSS custom-property name suffix, e.g. 'health' -> var(--accent-health). */
  readonly tokenSuffix: 'health' | 'selfcare' | 'study' | 'other';
  readonly Icon: LucideIcon;
}

const CATEGORY_META: Record<HabitCategory, HabitCategoryMeta> = {
  health: { label: 'Health', tokenSuffix: 'health', Icon: HeartPulse },
  self_care: { label: 'Self-care', tokenSuffix: 'selfcare', Icon: Sparkles },
  study: { label: 'Study', tokenSuffix: 'study', Icon: BookOpen },
  other: { label: 'Other', tokenSuffix: 'other', Icon: CircleEllipsis },
};

export function habitCategoryMeta(category: HabitCategory): HabitCategoryMeta {
  return CATEGORY_META[category];
}

export const HABIT_CATEGORIES: readonly HabitCategory[] = ['health', 'self_care', 'study', 'other'];
